export const PhoneConfirmationSymbols = {
    PhoneConfirmationProvider: Symbol.for("PhoneConfirmationProvider"),
    PhoneConfirmationService: Symbol.for("PhoneConfirmationService")
}